
import React from 'react'

export default function Pagination({ changePaginationIndex, totalPaginationNum, currentPaginationIndex }) {
    return <div className="paginationBox">
        <div
            onClick={() => {
                if (currentPaginationIndex - 1 >= 1) {
                    changePaginationIndex(currentPaginationIndex - 1)
                }
            }}
            className="paginationBtn">
            <div className="arrowIcon rightArrow2" />
        </div>
        {
            Array.from({ length: totalPaginationNum }, (_, index) => index + 1).map((v, i) => {
                let flag = currentPaginationIndex == v
                return <div
                    key={i}
                    onClick={() => {
                        changePaginationIndex(v)
                    }}
                    className="paginationBtn"
                    style={{
                        borderColor: flag ? '#00A6FF' : '#E3E3E3'
                    }}>
                    <div className="paginationBtnText"
                        style={{
                            color: flag ? '#00A6FF' : '#222'
                        }}>{v}</div>
                </div>
            })
        }
        <div
            onClick={() => {
                if (currentPaginationIndex + 1 <= totalPaginationNum) {
                    changePaginationIndex(currentPaginationIndex + 1)
                }
            }}
            className="paginationBtn">
            <div className="arrowIcon rightArrow3" />
        </div>
    </div>
}